export const categorySteps = [
    {
        target: '#tour-category-title',
        content: 'Bem-vindo ao cadastro de categorias! Aqui você organiza seus produtos e serviços em grupos.',
        placement: 'bottom',
        disableBeacon: true,
    },
    {
        target: '#tour-category-name',
        content: 'Informe o nome da categoria. Ex: "Bebidas", "Camisetas" ou "Cortes de Cabelo".',
    },
    {
        target: '#tour-category-desc',
        content: 'Uma breve descrição ajuda a identificar para que serve esta categoria.',
    },
    {
        target: '#tour-category-status',
        content: 'Você pode desabilitar uma categoria temporariamente se não for usá-la.',
    },
    {
        target: '#tour-category-particularity',
        content: 'Aqui está o segredo! Adicione características como "Tamanho" ou "Cor" para facilitar o cadastro dos produtos depois.',
    },
    {
        target: '#tour-category-add-btn',
        content: 'Tudo pronto? Clique em Adicionar para salvar sua nova categoria.',
    },
];

export const cashierNewSteps = [
    {
        target: '#tour-cashier-name',
        content: 'Dê um nome fácil de identificar. Ex: "Caixa Balcão" ou "Caixa Maria".',
        disableBeacon: true,
    },
    {
        target: '#tour-cashier-operators',
        content: 'Selecione quais funcionários poderão operar este caixa.',
    },
    {
        target: '#tour-cashier-save-btn',
        content: 'Clique aqui para registrar este novo caixa no sistema.',
    },
];

export const cashierLogisticSteps = [
    {
        target: '.UIFormTitle',
        content: 'Este é o painel de controle do seu caixa atual.',
        disableBeacon: true,
    },
    {
        target: '.UIModal__button-search',
        content: 'Para começar a vender, você precisa ABRIR o caixa. No final do dia, clique aqui para FECHAR e conferir os valores.',
    },
    {
        target: '.MuiTabs-root',
        content: 'Navegue pelas abas para ver Entradas, Saídas e o Balanço financeiro do seu turno.',
    },
];

export const stockSteps = [
    {
        target: '#tour-stock-abc-tab',
        content: 'Nesta aba você encontra a análise estratégica do seu estoque. O sistema classifica seus itens automaticamente.',
        placement: 'bottom',
        disableBeacon: true,
    },
    {
        target: '#tour-stock-filters',
        content: 'Use estes botões para filtrar: Classe A (Mais importantes), B ou C. O botão "Excesso" mostra produtos parados, e o "Repor" mostra o que está acabando.',
    },
    {
        target: '#tour-stock-search',
        content: 'Precisa de um item específico? Use a busca rápida por nome ou código.',
    },
    {
        target: '#tour-stock-table',
        content: 'Aqui você vê os detalhes: quanto tem em estoque, qual sua margem de lucro e quanto tempo o estoque atual vai durar (Cobertura).',
    },
    {
        target: '#tour-stock-urgent',
        content: 'Lembre-se: Itens com "Risco de Ruptura" são sua prioridade máxima de compra!',
    },
];

export const stockAbcSteps = stockSteps;

export const stockSuppliersSteps = [
    {
        target: '#tour-stock-replenishment-tab',
        content: 'Nesta aba você encontra a gestão inteligente de fornecedores. O sistema prevê a data ideal de compra com base no histórico e ritmo de vendas.',
        placement: 'bottom',
        disableBeacon: true,
    },
    {
        target: '#tour-replenishment-kpis',
        content: 'Aqui no topo você acompanha métricas consolidadas: fornecedores com produtos em falta (Ruptura), compras previstas para esta semana, quantidade total de itens e valor estimado.',
    },
    {
        target: '#tour-replenishment-search',
        content: 'Busque rapidamente por nome do fornecedor ou pelo nome de um produto específico.',
    },
    {
        target: '#tour-replenishment-filters',
        content: 'Use os filtros para priorizar o dia a dia: "Pedir Esta Semana", alertas críticos em "Ruptura" ou planejamento de "Próximos Ciclos".',
    },
    {
        target: '#tour-replenishment-card',
        content: 'Cada card apresenta o fornecedor com seu intervalo médio de compra, status da previsão, quantidade de unidades sugeridas e valor total estimado.',
    },
    {
        target: '#tour-replenishment-actions',
        content: 'Agilidade total: copie a lista de compras formatada ou envie o pedido direto no WhatsApp do fornecedor em um clique!',
    },
];

export const stockClosuresSteps = [
    {
        target: '#tour-stock-closures-tab',
        content: 'Nesta aba você visualiza o histórico de fechamentos e vigências do estoque para auditoria de períodos anteriores.',
        placement: 'bottom',
        disableBeacon: true,
    },
];

export const stockEntriesSteps = [
    {
        target: '#tour-stock-entries-tab',
        content: 'Acompanhe todas as entradas de mercadorias no estoque, compras de fornecedores e ajustes manuais.',
        placement: 'bottom',
        disableBeacon: true,
    },
];

export const stockOutsSteps = [
    {
        target: '#tour-stock-outs-tab',
        content: 'Acompanhe o registro de saídas de mercadorias geradas por vendas, perdas ou transferências.',
        placement: 'bottom',
        disableBeacon: true,
    },
];

export const serviceSteps = [
    {
        target: '#tour-service-title',
        content: 'Nesta tela você cadastra serviços ou cria Fichas Técnicas, Lanches, Drinks e Combos profissionais.',
        placement: 'bottom',
        disableBeacon: true,
    },
    {
        target: '#tour-service-name',
        content: 'Dê um nome ao seu serviço ou item. Ex: "X-Salada", "Caipirinha Especial" ou "Corte de Cabelo".',
    },
    {
        target: '#tour-service-value',
        content: 'Informe por quanto você vai vender este serviço ao seu cliente.',
    },
    {
        target: '#tour-service-composition',
        content: 'Aqui está a mágica! Você pode vincular insumos do estoque para montar a ficha técnica e calcular o custo exato da receita.',
    },
    {
        target: '#tour-service-input-search',
        content: 'Busque os ingredientes ou peças que compõem este serviço.',
    },
    {
        target: '#tour-service-input-amount',
        content: 'Informe a quantidade consumida ou use a Calculadora de Insumos para dosagens exatas em ml, g, doses ou frações.',
    },
    {
        target: '#tour-service-metrics',
        content: 'Fique de olho aqui! O sistema calcula o Custo Total dos insumos e sua Margem de Lucro em tempo real.',
    },
    {
        target: '#tour-service-cost-check',
        content: 'Dica: Ative esta opção se o valor desse serviço deve ser repassado a alguém (ex: taxa de entrega para o motoqueiro ou comissão). O sistema gerará uma conta a pagar automaticamente.',
    },
    {
        target: '#tour-service-save-btn',
        content: 'Pronto! Clique em Salvar para registrar seu serviço ou receita.',
    },
];

export const productNewSteps = [
    {
        target: '#tour-product-tabs',
        content: 'Bem-vindo ao novo cadastro de produtos! Aqui você organiza Dados Gerais, Preços, Estoque Inicial e os Formatos de Venda.',
        placement: 'bottom',
        disableBeacon: true,
    },
    {
        target: '#tour-product-category',
        content: 'Na aba Dados Gerais, escolha a categoria. Se ela tiver características (Tamanho, Cor, Marca ou Sabor), preencha as particularidades exigidas.',
    },
    {
        target: '#tour-product-formats-tab',
        content: 'Formatos de Venda: Vamos até esta aba para ver como cadastrar frações e porções do mesmo produto.',
    },
    {
        target: '#tour-product-formats-header',
        content: 'Formatos Fracionados & Derivados: Permite vender doses, copos, fardos, caixas ou unidades avulsas abatendo proporcionalmente do estoque da embalagem principal.',
    },
    {
        target: '#tour-product-add-format-btn',
        content: 'Clique em "Adicionar Formato" para abrir o assistente e configurar uma nova opção de venda (ex: Dose de 50ml, Garrafa, Lata ou Kg).',
    },
    {
        target: '#tour-product-formats-container',
        content: 'Cálculo de Custo & Margem Automático: O sistema calcula o custo de cada porção ou dose com base no custo do produto pai e apura a margem de lucro de cada formato.',
    },
    {
        target: '#tour-product-formats-stock-info',
        content: 'Baixa de Estoque Proporcional: Ao vender qualquer formato no PDV ou bipar o código de barras próprio, a baixa proporcional é descontada automaticamente do saldo do produto pai!',
    },
    {
        target: '.UIFormContainerSave__buttons-saved',
        content: 'Tudo pronto! Preencha as abas e clique em Salvar para registrar seu produto com todos os formatos prontos para vender!',
    },
];

export const productSaleFormatsSteps = [
    {
        target: '#tour-product-formats-header',
        content: 'Bem-vindo ao painel de Formatos de Venda! Aqui você cadastra formas derivadas de venda (doses, porções, fardos ou latas) vinculadas ao mesmo produto pai.',
        placement: 'bottom',
        disableBeacon: true,
    },
    {
        target: '#tour-product-add-format-btn',
        content: 'Clique em "Adicionar Formato" para abrir o assistente e cadastrar uma nova opção de venda.',
    },
    {
        target: '#tour-product-formats-container',
        content: 'Cada formato possui seu próprio fator de conversão, cálculo automático de custo por porção, margem de lucro e código de barras próprio para leitura no PDV.',
    },
    {
        target: '#tour-product-formats-stock-info',
        content: 'Controle de estoque automático: ao vender qualquer formato, a baixa proporcional é descontada diretamente do saldo do produto principal.',
    },
    {
        target: '.UIFormContainerSave__buttons-saved',
        content: 'Clique em Salvar para gravar todas as alterações do produto.',
    },
];

export const costsSearchSteps = [
    {
        target: '.UIFormTitle',
        content: 'Bem-vindo à Gestão de Custos! Aqui você controla todas as despesas da sua empresa.',
        placement: 'bottom',
        disableBeacon: true,
    },
    {
        target: '#tour-costs-search-name',
        content: 'Procure por um custo específico pelo nome.',
    },
    {
        target: '#tour-costs-search-bysystem',
        content: 'Filtre entre custos manuais e automáticos (gerados pelo sistema).',
    },
];

export const costsNewSteps = [
    {
        target: '#tour-costs-new-name',
        content: 'Dê um nome ao custo. Ex: "Aluguel Loja" ou "Energia Elétrica".',
        disableBeacon: true,
    },
    {
        target: '#tour-costs-new-recurrent',
        content: 'Aqui está a novidade! Ative esta opção para que o sistema gere esta conta automaticamente todos os meses (ou na frequência que você desejar).',
    },
    {
        target: '#tour-costs-new-recurrent-settings',
        content: 'Após ativar, use esta engrenagem para definir o dia de vencimento e se deseja ser notificado antecipadamente.',
    },
    {
        target: '#tour-costs-new-save',
        content: 'Preencha os valores e clique em Salvar para finalizar o cadastro.',
    },
];

export const planningSteps = [
    {
        target: '#tour-planning-title',
        content: 'Bem-vindo ao Dashboard de Saúde & Performance! Este painel oferece uma visão 360° do seu negócio, unindo o que já aconteceu com o que está por vir.',
        placement: 'bottom',
        disableBeacon: true,
    },
    {
        target: '#tour-planning-scoreboard',
        content: 'O Placar mostra o resumo do mês atual. Aqui você vê o faturamento real atingido e como ele se compara à meta estimada pelo sistema.',
    },
    {
        target: '#tour-planning-estimates-expl',
        content: 'Como funcionam as estimativas? O sistema analisa seu histórico dos últimos meses e as vendas já agendadas para projetar seu faturamento e custos futuros, ajudando você a se antecipar.',
    },
    {
        target: '#tour-planning-raiox',
        content: 'No Raio-X, comparamos em detalhes o Realizado vs Estimado. As barras mostram se você está dentro do esperado para faturamento, custos e lucro.',
    },
    {
        target: '#tour-planning-efficiency',
        content: 'A Eficiência de Vendas foca na qualidade. Veja seu Ticket Médio e o Ticket Efetivo (quanto sobra após a inadimplência), facilitando o ajuste de preços e estratégias.',
    },
    {
        target: '#tour-planning-inadimplencia',
        content: 'Fique de olho na Inadimplência! Aqui você entende o peso das vendas não pagas no seu bolso e quanto de receita potencial está "fugindo".',
    },
    {
        target: '#tour-planning-cashflow',
        content: 'O Fluxo de Caixa e Previsões une seus recebíveis já confirmados com a base histórica para projetar seu resultado financeiro final do mês.',
    },
    {
        target: '#tour-planning-trend',
        content: 'A linha de Tendência mostra o fluxo de 6 meses. A linha sólida é o passado real, e a linha pontilhada é a nossa projeção baseada em dados. Planeje-se com antecedência!',
    },
    {
        target: '#tour-planning-print',
        content: 'Precisa levar esses dados para uma reunião? Gere um relatório completo e profissional clicando aqui.',
    },
];

export const userNewSteps = [
    {
        target: '#tour-user-active',
        content: 'Você pode criar um usuário inativo e ativá-lo depois. Um usuário inativo não consegue acessar o sistema.',
        disableBeacon: true,
    },
    {
        target: '#tour-user-name',
        content: 'Preencha o nome e sobrenome do seu colaborador.',
    },
    {
        target: '#tour-user-cpf',
        content: 'O CPF é importante para a identificação única do usuário.',
    },
    {
        target: '#tour-user-login',
        content: 'Defina um nome de usuário para o login. Dica: use algo fácil de lembrar.',
    },
    {
        target: '#tour-user-password',
        content: 'Crie uma senha segura e confirme-a no campo ao lado.',
    },
    {
        target: '#tour-user-profile',
        content: 'Escolha o nível de acesso: Operador (vendas), Gerente (vendas + relatórios) ou Administrador (acesso total).',
    },
    {
        target: '#tour-user-cashier',
        content: 'Vincule este usuário aos caixas que ele poderá operar. Um usuário pode ter acesso a vários caixas simultaneamente.',
    },
    {
        target: '#tour-user-save',
        content: 'Tudo pronto! Clique aqui para cadastrar o novo usuário no sistema.',
    },
];

export const scheduleAgendaSteps = [
    {
        target: '#tour-schedule-header',
        content: 'Bem-vindo à agenda de agendamentos! Aqui você visualiza e gerencia todos os seus compromissos de forma organizada.',
        placement: 'bottom',
        disableBeacon: true,
    },
    {
        target: '#tour-schedule-date-picker',
        content: 'Clique aqui para abrir o seletor de datas e navegar rapidamente para qualquer dia.',
    },
    {
        target: '#tour-schedule-navigation',
        content: 'Use as setas para navegar entre semanas (pc) ou dias (celular). O botão "Ir Para Hoje" leva você de volta para a data atual.',
    },
    {
        target: '#tour-schedule-new-btn',
        content: 'Clique aqui para criar um novo agendamento rapidamente.',
    },
    {
        target: '#tour-schedule-calendar-grid',
        content: 'Esta é a visualização do calendário. Você pode clicar em qualquer espaço em branco para criar um agendamento naquele horário específico!',
    },
    {
        target: '#tour-schedule-calendar-grid',
        content: 'Os agendamentos aparecem coloridos no calendário. Clique neles para ver detalhes, reagendar, enviar lembretes ou finalizar o atendimento.',
        placement: 'top',
    },
];

export const customerProfilesSteps = [
    {
        target: '#tour-profiles-title',
        content: 'Bem-vindo aos Perfis de Clientes! Aqui você cria regras automáticas para segmentar seus clientes em grupos como "Fiéis", "Inativos" ou "Alto Valor".',
        placement: 'bottom',
        disableBeacon: true,
    },
    {
        target: '#tour-profiles-new-btn',
        content: 'Clique aqui para criar um novo perfil. Você pode definir critérios demográficos, financeiros e temporais para categorizar automaticamente seus clientes.',
    },
    {
        target: '#tour-profiles-table',
        content: 'Todos os perfis criados aparecem nesta tabela. Use os botões de editar e excluir para gerenciar seus perfis existentes.',
    },
];

export const customerProfilesModalSteps = [
    {
        target: '#tour-profile-section-identification',
        content: 'Comece dando um nome ao perfil e escolhendo o tipo: "Perfil Bom" (para clientes que você quer fidelizar) ou "Perfil Ruim" (para clientes com comportamento negativo, como inadimplentes).',
        placement: 'bottom',
        disableBeacon: true,
    },
    {
        target: '#tour-profile-section-demographic',
        content: 'Filtre por critérios demográficos: faixa etária, quantidade de filhos, gênero e estado civil. Passe o mouse sobre qualquer campo para ativá-lo.',
    },
    {
        target: '#tour-profile-section-location',
        content: 'Restrinja o perfil a clientes de cidades específicas. Você pode selecionar cidades cadastradas ou digitar novas.',
    },
    {
        target: '#tour-profile-section-financial',
        content: 'Use as métricas financeiras para segmentar por valor: ticket médio, total gasto, vendas pendentes, valor fiado e descontos. Cada métrica aceita um intervalo (slider) ou um valor mínimo.',
    },
    {
        target: '#tour-profile-section-temporal',
        content: 'As métricas temporais são a chave para identificar padrões de comportamento: quando foi a última compra, há quanto tempo o cliente é seu, e qual a frequência de pagamento.',
    },
];

export const customerAnalysisSteps = [
    {
        target: '#tour-analysis-header',
        content: 'Este é o painel de Análise do Cliente. Aqui você encontra uma visão 360° do relacionamento, com métricas financeiras, comportamentais e sugestões de retenção.',
        placement: 'bottom',
        disableBeacon: true,
    },
    {
        target: '#tour-analysis-health',
        content: 'A barra de Saúde mostra a qualidade do relacionamento. Clientes com muitas vendas pagas têm pontuação alta. Inadimplência e pendências reduzem a nota.',
    },
    {
        target: '#tour-analysis-financial-kpis',
        content: 'As Métricas Financeiras mostram o faturamento total, ticket médio, valor fiado, descontos e quantidade de compras deste cliente.',
    },
    {
        target: '#tour-analysis-temporal-kpis',
        content: 'As Métricas Temporais revelam o comportamento do cliente: quando comprou pela última vez, há quanto tempo é cliente, e qual o intervalo médio entre compras e pagamentos.',
    },
    {
        target: '#tour-analysis-top-items',
        content: 'Veja quais produtos e serviços este cliente mais consome. Use essa informação para criar ofertas personalizadas!',
    },
    {
        target: '#tour-analysis-history',
        content: 'O histórico completo de compras mostra cada transação, valor, pagamento e status. Identifique padrões de compra e inadimplência.',
    },
    {
        target: '#tour-analysis-ai',
        content: 'O Agente de Retenção da Dux IA analisa todo o histórico e sugere uma estratégia personalizada, incluindo mensagem para WhatsApp e sugestões de desconto. Clique no botão para gerar a análise!',
    },
];

export const allSteps = {
    category: categorySteps,
    cashierNew: cashierNewSteps,
    cashierLogistic: cashierLogisticSteps,
    stock: stockSteps,
    stockAbc: stockAbcSteps,
    stockSuppliers: stockSuppliersSteps,
    stockClosures: stockClosuresSteps,
    stockEntries: stockEntriesSteps,
    stockOuts: stockOutsSteps,
    service: serviceSteps,
    productNew: productNewSteps,
    productSaleFormats: productSaleFormatsSteps,
    costs: costsSearchSteps,
    costsNew: costsNewSteps,
    planning: planningSteps,
    userNew: userNewSteps,
    scheduleAgenda: scheduleAgendaSteps,
    customerProfiles: customerProfilesSteps,
    customerProfilesModal: customerProfilesModalSteps,
    customerAnalysis: customerAnalysisSteps,
};
